@for (item of entityTreeData | keyvalue; track item) {
  <section class="mb-5"  [id]="'tree-section' + item.key">
    @if (showTitle) {
      <h4 class="node-title">{{item.value.title}}</h4>
    }
    <mat-accordion class="example-headers-align">
      @for (link of item.value.children; track link) {
        <mat-expansion-panel (opened)="getHtml(link.uri, link.typeVar)">
          <mat-expansion-panel-header>
            <mat-panel-title>{{link.title}}</mat-panel-title>
          </mat-expansion-panel-header>
          @if (htmlData[link.uri]) {
            <p  spinEl [spinning]="!htmlData[link.uri]" [innerHTML]="htmlData[link.uri] | safe: 'html'" ></p>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </section>
}

